<template>
    <div>
        <b-row class="mb-2">
            <b-col>
                <b-button v-if="Core.Session.AuthUser.can('order_management_post')"  @click="add" class="btn btn-light pull-right">{{Core.Definition.getDefinition('Nouvelle commande')}}</b-button>
            </b-col>
        </b-row>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'OrderContainer',
        components: {
        },
        mounted() {
        },
        data () {
            return {
                Core: window.Core
            }
        },
        methods: {
            add() {
                if (this.$route.fullPath === window.Core.Definition.getDefinition('/commerce/commandes/nouvelle-commande')) {
                    location.reload()
                } else {
                    this.$router.push(window.Core.Definition.getDefinition('/commerce/commandes/nouvelle-commande'))
                }
            }
        }
    }
</script>
